import { render, staticRenderFns } from "./communicationList.vue?vue&type=template&id=d0b469f8&scoped=true&"
import script from "./communicationList.vue?vue&type=script&lang=js&"
export * from "./communicationList.vue?vue&type=script&lang=js&"
import style0 from "./communicationList.vue?vue&type=style&index=0&id=d0b469f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b469f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0b469f8')) {
      api.createRecord('d0b469f8', component.options)
    } else {
      api.reload('d0b469f8', component.options)
    }
    module.hot.accept("./communicationList.vue?vue&type=template&id=d0b469f8&scoped=true&", function () {
      api.rerender('d0b469f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/communication/communicationList.vue"
export default component.exports